import { Component, inject } from '@angular/core';
import { CreateAufgabeFormService } from '@schir-int-client/aufgabe';
import { CreateLfprVerfuegungFormservice } from './create-lfpr-verfuegung.formservice';
import { AufgabenTyp, aufgabenTypenForRegister } from '@schir-int-client/aufgabe-shared';
import { BaseEditorComponent } from '@schir-int-client/tech';
import { UntypedFormGroup } from '@angular/forms';
import { VerfahrenFacade } from '@schir-int-client/verfahren-shared';
import { filter } from 'rxjs/operators';
import { isNotNullOrUndefined } from '../../../../../tech/src/lib/filter/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'schir-int-client-create-lfpr-verfuegung-dialog',
	templateUrl: './create-lfpr-verfuegung-dialog.component.html',
	styleUrls: ['./create-lfpr-verfuegung-dialog.component.scss'],
	providers: [CreateLfprVerfuegungFormservice, CreateAufgabeFormService],
	standalone: false,
})
export class CreateLfprVerfuegungDialogComponent extends BaseEditorComponent {
	readonly formService = inject(CreateLfprVerfuegungFormservice);
	readonly aufgabeFormService = inject(CreateAufgabeFormService);
	readonly verfahrenFacade = inject(VerfahrenFacade);

	readonly aufgabenTypen = AufgabenTyp;
	valideAufgabenTypen: Array<AufgabenTyp> = [];

	constructor() {
		super();
		this.verfahrenFacade.verfahrenSingle
			.pipe(
				takeUntilDestroyed(),
				filter(v => isNotNullOrUndefined(v))
			)
			.subscribe(v => (this.valideAufgabenTypen = aufgabenTypenForRegister(v.register, true)));
	}

	get form(): UntypedFormGroup {
		return this.formService.form;
	}

	isValid(): boolean {
		return this.formService.checkPreconditions();
	}

	async submit(): Promise<boolean> {
		return this.formService.submit();
	}

	protected toggleGroup(aufgabenTyp: AufgabenTyp, enable: boolean) {
		if (enable) {
			this.aufgabeFormService.enableAufgabenTyp(aufgabenTyp);
		} else {
			this.aufgabeFormService.disableAufgabenTyp(aufgabenTyp);
		}
		this.form.markAsDirty();
	}
}
